<script>
    import { onMount } from "svelte";

    let tokenName = "";
    let tokens = [];
    let error = null;
    let csrf_token = null;
    let copiedToken = null;
    let selectedToken = null;

    onMount(async () => {
        csrf_token = document.querySelector('input[name="csrfmiddlewaretoken"]')?.value;
        await fetchTokens();
    });

    async function fetchTokens() {
        fetch("/api/tokens/list")
        .then((response) => {
            if (!response.ok) throw new Error("Failed to fetch tokens");
            return response.json();
        })
        .then((data) => {
            tokens = data.tokens;
        })
        .catch((err) => {
            error = err.message;
        });
    }

    async function createToken() {
        if (!tokenName.trim()) {
            error = "Please enter a name for the token.";
            return;
        }

        try {
            let formData = new FormData();
            formData.append("name", tokenName);
            const response = await fetch("/api/tokens/save/", {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrf_token,
                },
                body: formData,
            });

            if (!response.ok) throw new Error("Failed to create token");

            const newToken = await response.json();
            tokens = [...tokens, newToken]; // Update UI
            closeModal();
        } catch (err) {
            error = err.message;
        }
    }
    async function copyToClipboard(tokenKey) {
        try {
            await navigator.clipboard.writeText(tokenKey);
            copiedToken = tokenKey;
            console.log(copiedToken);

            // Hide the message after 1.5 seconds
            setTimeout(() => {
                console.log(copiedToken);
                copiedToken = null;
            }, 1500);
        } catch (err) {
            alert("Failed to copy token.");
        }
    }

    function openModal() {
        tokenName = "";
        error = null;
        let myModal = bootstrap.Modal.getInstance(document.getElementById("tokenModal"));
        myModal.show();
    }

    function closeModal() {
        let myModal = bootstrap.Modal.getInstance(document.getElementById("tokenModal"));
        myModal.hide();
    }

    function openDeleteModal(token) {
        selectedToken = token;
        let myModal = bootstrap.Modal.getInstance(document.getElementById("deleteModal"));
        myModal.show();
    }

    function confirmDelete() {
        if (!selectedToken) return;

        fetch(`/api/tokens/delete/${selectedToken.id}/`, {
            method: "DELETE",
            headers: {
                "X-CSRFToken": csrf_token,
            },
        })
        .then((response) => {
            if (!response.ok) throw new Error("Failed to delete token");
            tokens = tokens.filter((token) => token.key !== selectedToken.key);
            selectedToken = null;
            let myModal = bootstrap.Modal.getInstance(document.querySelector("#deleteModal"));
            myModal.hide();
        })
        .catch((err) => {
            error = err.message;
        });
    }
</script>
<style>
    .copied-tooltip {
        position: absolute;
        top: -30px; /* Adjusts position above the button */
        left: 50%;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 5px 10px;
        font-size: 12px;
        border-radius: 5px;
        white-space: nowrap;
        animation: fadeOut 1.5s ease-in-out forwards;
    }

    @keyframes fadeOut {
        0% { opacity: 1; }
        80% { opacity: 1; }
        100% { opacity: 0; }
    }
</style>
<div class="container mt-4">
    {#if error}
        <div class="alert alert-danger">{error}</div>
    {/if}
    <div class="rounded-5 mx-2 mx-lg-0 border border-dark shadow p-5">
        <div class="d-flex justify-content-between align-items-center">
            <h3>API Tokens</h3>
            <button on:click={openModal} class="btn btn-dark my-3" data-bs-toggle="modal" data-bs-target="#tokenModal">
                Add Token
            </button>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
                <thead class="">
                    <tr>
                        <th>Name</th>
                        <th>Token</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {#each tokens as token (token.key)}
                        <tr>
                            <td>{token.name}</td>
                            <td class="text-monospace position-relative">
                                {token.key} 
                                <button on:click={() => copyToClipboard(token.key)} class="btn btn-sm btn-secondary ms-2">
                                <i class="fa-regular fa-clipboard"></i></button>

                                {#if copiedToken == token.key}
                                    <div class="copied-tooltip">Token copied!</div>
                                {/if}
                            </td>
                            <td>{new Date(token.created_at).toLocaleString()}</td>
                            <td>
                                <button on:click={() => openDeleteModal(token)} class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal">
                                    <i class="fa-solid fa-trash"></i> Delete
                                </button>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
    </div>
</div>


<!-- Bootstrap Modal for Adding Token -->
<div class="modal fade" id="tokenModal" tabindex="-1" aria-labelledby="tokenModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="tokenModalLabel">Create API Token</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <input type="text" bind:value={tokenName} placeholder="Token Name" class="form-control mb-2" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-dark" on:click={createToken}>Create</button>
            </div>
        </div>
    </div>
</div>

<!-- Bootstrap Modal for Adding Token -->
<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Delete Token?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete the token <strong>{selectedToken?.name}</strong>?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger" on:click={confirmDelete}>Delete</button>
            </div>
        </div>
    </div>
</div>